import "./style.less";

import modalComponents from "./components/";
import cookieModalController from "./controller";

const modul = angular
    .module("cookieModal", [modalComponents])

    .controller("cookieModalController", cookieModalController);

export default modul.name;
